// FFT zodiac compatibility. For each sign: which signs are "Good" or "Bad"
// matches, and its "opposite" sign. Opposite pairings resolve to "Best"
// (different gender), "Worst" (same gender), or "Bad" (either is a Monster).
// Serpentarius is "Neutral" with everything; anything unlisted is "Neutral".
//
// Extracted from hoverUnit.vue so the fight view can reuse it.

// The 12 western signs + FFT's bonus Serpentarius, as [name, glyph] pairs, plus a
// name→glyph lookup. Shared by the player pages so the symbol map lives in one place.
export const ZODIAC = [
  ['Aries', '♈'], ['Taurus', '♉'], ['Gemini', '♊'], ['Cancer', '♋'],
  ['Leo', '♌'], ['Virgo', '♍'], ['Libra', '♎'], ['Scorpio', '♏'],
  ['Sagittarius', '♐'], ['Capricorn', '♑'], ['Aquarius', '♒'], ['Pisces', '♓'],
  ['Serpentarius', '⛎'],
];
export const SIGN_SYM = Object.fromEntries(ZODIAC);

export const COMPAT_TABLE = {
  Aries:       { good: ['Sagittarius', 'Leo'],   bad: ['Cancer', 'Capricorn'],   opposite: 'Libra'       },
  Taurus:      { good: ['Virgo', 'Capricorn'],   bad: ['Leo', 'Aquarius'],       opposite: 'Scorpio'     },
  Gemini:      { good: ['Libra', 'Aquarius'],    bad: ['Pisces', 'Virgo'],       opposite: 'Sagittarius' },
  Cancer:      { good: ['Scorpio', 'Pisces'],    bad: ['Libra', 'Aries'],        opposite: 'Capricorn'   },
  Leo:         { good: ['Sagittarius', 'Aries'], bad: ['Scorpio', 'Taurus'],     opposite: 'Aquarius'    },
  Virgo:       { good: ['Capricorn', 'Taurus'],  bad: ['Sagittarius', 'Gemini'], opposite: 'Pisces'      },
  Libra:       { good: ['Aquarius', 'Gemini'],   bad: ['Cancer', 'Capricorn'],   opposite: 'Aries'       },
  Scorpio:     { good: ['Pisces', 'Cancer'],     bad: ['Aquarius', 'Leo'],       opposite: 'Taurus'      },
  Sagittarius: { good: ['Aries', 'Leo'],         bad: ['Pisces', 'Virgo'],       opposite: 'Gemini'      },
  Capricorn:   { good: ['Taurus', 'Virgo'],      bad: ['Libra', 'Aries'],        opposite: 'Cancer'      },
  Aquarius:    { good: ['Gemini', 'Libra'],      bad: ['Taurus', 'Scorpio'],     opposite: 'Leo'         },
  Pisces:      { good: ['Cancer', 'Scorpio'],    bad: ['Sagittarius', 'Gemini'], opposite: 'Virgo'       },
};

// Compatibility of `my` unit acting on `they` unit -> 'Good'|'Bad'|'Best'|
// 'Worst'|'Neutral'. Damage modifiers: Good ±¼, Best/Worst ±½.
export function zodiacCompat(myGender, mySign, theyGender, theySign) {
  if (mySign === 'Serpentarius' || theySign === 'Serpentarius') return 'Neutral';
  const entry = COMPAT_TABLE[mySign];
  if (!entry) return 'Neutral';
  if (entry.good.includes(theySign)) return 'Good';
  if (entry.bad.includes(theySign)) return 'Bad';
  if (entry.opposite === theySign) {
    if (myGender === 'Monster' || theyGender === 'Monster') return 'Bad';
    return myGender === theyGender ? 'Worst' : 'Best';
  }
  return 'Neutral';
}
